import { render, staticRenderFns } from "./IngredientPublish.vue?vue&type=template&id=42b0262c&"
import script from "./IngredientPublish.vue?vue&type=script&lang=js&"
export * from "./IngredientPublish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports